import {getPersonal} from 'redux/actions/Personal';
import {useEffect, useState} from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import classes from './Addressbook.module.css';
import {useDispatch, useSelector} from 'react-redux';
import {Paper} from '@mui/material';
import PropTypes from 'prop-types';
import InfoDialog from '../InfoDialog';
import useModal from 'shared/hooks/useModal';

const columns = [
  {id: 'person', label: 'Nama', minWidth: 170},
  // { id: 'code', label: 'Kode', minWidth: 170 },
];

const AddressbookPersonal = ({
  multiselect,
  setPayloadOnHide,
  setPilihan,
  pilihan,
  searchText,
}) => {
  const dispatch = useDispatch();
  const tmpData = useSelector(({personal}) => {
    return personal.detail;
  });
  useEffect(() => {
    dispatch(getPersonal(searchText));
  }, [searchText]);
  const [selectedRow, setSelected] = useState(undefined);
  const handleClick = (item) => {
    setSelected(item);
  };

  const handleDoubleClick = (item) => {
    let tmp = {
      id: item.code,
      text: item.person,
      code: item.code,
      oriItem: item,
    };
    if (multiselect) {
      let exist = pilihan.findIndex((item) => {
        return item.code === tmp.code;
      });
      if (exist > -1) {
        setInfo(tmp.text + ' sudah dipilih');
        toggleShowInfo(true);
      } else setPilihan((pilihan) => [...pilihan, tmp]);
    } else {
      setPilihan([tmp]);
      setPayloadOnHide([tmp]);
    }
    setSelected(undefined);
  };

  const {
    stateAddress: stateInfo,
    toggleShow: toggleShowInfo,
    toggleHide: toggleHideInfo,
  } = useModal();
  const [infoMsg, setInfo] = useState('');

  let selected_code = selectedRow ? selectedRow.code : undefined;
  return (
    <Paper>
      <TableContainer sx={{maxHeight: '100%', overflow: 'hidden'}}>
        <Table stickyHeader size='small' aria-label='sticky table'>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{minWidth: column.minWidth}}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tmpData &&
              tmpData.map((row) => {
                return (
                  <TableRow
                    hover
                    role='checkbox'
                    className={
                      selected_code === row.code
                        ? classes.click + ' ' + classes.selected
                        : classes.click
                    }
                    tabIndex={-1}
                    key={row.code}
                    onClick={() => handleClick(row)}
                    onDoubleClick={() => handleDoubleClick(row)}
                  >
                    {columns.map((column) => {
                      let value;
                      value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === 'number'
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <InfoDialog
        stateAddress={stateInfo}
        toggleHide={toggleHideInfo}
        msg={infoMsg}
      />
    </Paper>
  );
};

export default AddressbookPersonal;

AddressbookPersonal.propTypes = {
  multiselect: PropTypes.bool,
  setPayloadOnHide: PropTypes.func,
  setPilihan: PropTypes.func,
  pilihan: PropTypes.array,
  searchText: PropTypes.any,
};
